import FormattedMessage from 'I18n/components/FormattedMessage';
import { Drawer, Heading, LayoutHorizontal, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { MatchRatePropertiesGrid } from './MatchRatePropertiesGrid';
import { PanelHeader } from './PanelHeader';
import { SectionMatchRate } from './SectionMatchRate';
import { useDataTest } from './useDataTest/useDataTest';
import { DataTestError } from './DataTestError';
import { DataTestLoading } from './DataTestLoading';
import { OverwriteSetting } from '../OverwriteSetting';
import { useEnrichableObjectTypes } from '../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertiesHeading = ({
  isContactEnrichment
}) => {
  const {
    companyLabel,
    contactLabel
  } = useEnrichableObjectTypes();
  if (isContactEnrichment) return /*#__PURE__*/_jsx(Heading, {
    as: "h5",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.matchRate.contacts.propertiesTitle",
      options: {
        objectType: contactLabel
      }
    })
  });
  return /*#__PURE__*/_jsx(Heading, {
    as: "h5",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.matchRate.companies.propertiesTitle",
      options: {
        objectType: companyLabel
      }
    })
  });
};
export function DataTestContent() {
  const {
    isContactEnrichment,
    properties,
    recordsIneligible,
    recordsEligible,
    recordsSelected,
    recordsEnrichable,
    shouldOverwrite,
    setShouldOverwrite
  } = useDataTest();
  return /*#__PURE__*/_jsx(Drawer.Body, {
    children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      gap: "space-xxl",
      children: [/*#__PURE__*/_jsx(PanelHeader, {}), /*#__PURE__*/_jsx(DataTestLoading, {
        children: /*#__PURE__*/_jsxs(DataTestError, {
          children: [/*#__PURE__*/_jsx(SectionMatchRate, {
            isContactEnrichment: isContactEnrichment,
            recordsEligible: recordsEligible,
            recordsEnrichable: recordsEnrichable,
            recordsIneligible: recordsIneligible,
            recordsSelected: recordsSelected
          }), /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
            gap: "space-md",
            children: [/*#__PURE__*/_jsxs(LayoutHorizontal, {
              justifyContent: "space-between",
              paddingInline: "space-xl",
              children: [/*#__PURE__*/_jsx(PropertiesHeading, {
                isContactEnrichment: isContactEnrichment
              }), /*#__PURE__*/_jsx(OverwriteSetting, {
                checked: shouldOverwrite,
                id: "datatest-overwrite-setting",
                onChange: setShouldOverwrite
              })]
            }), /*#__PURE__*/_jsx(MatchRatePropertiesGrid, {
              properties: properties
            })]
          })]
        })
      })]
    })
  });
}